/* unplugin-vue-components disabled */import script from "./TimetableApp.vue?vue&type=script&setup=true&lang=js"
export * from "./TimetableApp.vue?vue&type=script&setup=true&lang=js"

import "./TimetableApp.vue?vue&type=style&index=0&id=f79b9b3a&lang=scss"

const __exports__ = script;

export default __exports__